webpackJsonp([212839066777427],{

/***/ 219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Index;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(23);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _singleFormLayout = __webpack_require__(248);
	
	var _singleFormLayout2 = _interopRequireDefault(_singleFormLayout);
	
	var _navbar = __webpack_require__(44);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _mobileContent = __webpack_require__(70);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _formsShared = __webpack_require__(91);
	
	var _palette = __webpack_require__(17);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _color = __webpack_require__(94);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _icons = __webpack_require__(92);
	
	var _mobileDetect = __webpack_require__(87);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	__webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var windowWidth = typeof window !== 'undefined' && window.innerWidth;
	var md = typeof window !== 'undefined' ? new _mobileDetect2.default(window.navigator.userAgent) : { mobile: function mobile() {
	    return false;
	  } };
	var isMobile = md.mobile();
	
	var STYLES = _extends((_extends2 = {
	  blogHeaderWrap: {
	    backgroundColor: _palette2.default.COAL,
	    position: 'relative',
	    paddingTop: 90,
	    paddingBottom: 30,
	    color: _palette2.default.SUNSTONE,
	    textAlign: 'center',
	    '@media screen and (max-width: 1115px)': {
	      marginTop: 0
	    }
	  },
	  flexContentWrap: {
	    display: 'flex',
	    justifyContent: 'center',
	    marginTop: 50,
	    marginBottom: 50,
	    '@media screen and (max-width: 1115px)': {
	      marginTop: 0
	    }
	  },
	  postsContentWrap: {
	    width: '100%',
	    maxWidth: 1000,
	    height: '100%',
	    paddingLeft: 20,
	    paddingRight: 20,
	    '@media screen and (max-width: 1115px)': {
	      width: '90%',
	      paddingLeft: 10,
	      paddingRight: 10
	    }
	  },
	  subtitle: {
	    color: _palette2.default.ROCK,
	    fontSize: 15,
	    marginTop: 5,
	    fontWeight: 300,
	    lineHeight: '22px'
	  },
	  flexGrid: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    alignContent: 'flex-start',
	    flexWrap: 'wrap',
	    '@media screen and (max-width: 1115px)': {
	      display: 'block'
	    }
	  },
	  flexGridImage: {
	    position: 'relative',
	    float: 'left',
	    width: '34%',
	    height: '100%'
	  },
	  flexGridContent: {
	    padding: '0px 40px 12px 40px',
	    position: 'relative',
	    float: 'left',
	    width: '66%'
	  },
	  h2: {
	    color: _palette2.default.SUNSTONE,
	    minHeight: '2em',
	    fontSize: 21,
	    letterSpacing: .5,
	    lineHeight: '27px',
	    wordWrap: 'break-word',
	    fontFamily: 'brandon-grotesque',
	    textTransform: 'uppercase',
	    paddingTop: 15,
	    margin: '12px 0 12px'
	  }
	}, _extends2['subtitle'] = {
	  color: '#d7e1e2',
	  fontSize: 15,
	  marginTop: 10,
	  fontWeight: 300,
	  lineHeight: '22px'
	}, _extends2.title = {
	  color: 'white'
	}, _extends2.date = {
	  marginTop: -2,
	  marginBottom: 0,
	  fontSize: 12,
	  color: (0, _color2.default)(_palette2.default.DARKER_ROCK).darken(.2)
	}, _extends2.hideOnMobile = {
	  '@media screen and (max-width: 700px)': {
	    display: 'none'
	  }
	}, _extends2.tag = {
	  fontSize: 12,
	  background: _palette2.default.LIGHTEST_PINK,
	  color: _palette2.default.SUNSTONE,
	  borderRadius: 4,
	  padding: 3,
	  display: 'inline-block',
	  marginTop: 8
	}, _extends2), _formsShared.FORM_STYLES);
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Blog | Haiku'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Where Designing is building. Thoughts on interaction design, animation and code.' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Blog | Haiku' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'Where Designing is building. Thoughts on interaction design, animation and code.' })
	    ),
	    _react2.default.createElement(_navbar2.default, { location: 'blog' }),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto'
	        } },
	      _react2.default.createElement(
	        'div',
	        { style: STYLES.blogHeaderWrap },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { style: STYLES.title, to: '/blog/' },
	          _react2.default.createElement(_icons.HaikuIconGradioSVG, { width: 80, height: 80 }),
	          _react2.default.createElement(
	            'h1',
	            { style: { marginTop: 20 } },
	            'Haiku Blog'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: STYLES.subtitle },
	            'Articles, videos and resources by the Haiku team.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: STYLES.flexContentWrap },
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.postsContentWrap },
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.flexGrid },
	            posts.filter(function (post) {
	              return post.node.frontmatter.title.length > 0;
	            }).map(function (_ref2, index) {
	              var post = _ref2.node;
	
	              return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.frontmatter.path, tabIndex: index + 10, className: 'flexGridBlog', key: post.id },
	                _react2.default.createElement(
	                  'div',
	                  { style: STYLES.flexGridImage },
	                  _react2.default.createElement('img', { className: 'blogFeatureImage', src: post.frontmatter.coverImage.publicURL, alt: post.frontmatter.title })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: STYLES.flexGridContent },
	                  _react2.default.createElement(
	                    'h2',
	                    { style: STYLES.h2 },
	                    post.frontmatter.title
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { style: STYLES.date },
	                    post.frontmatter.date
	                  ),
	                  post.frontmatter.tags && post.frontmatter.tags.map(function (tag) {
	                    return _react2.default.createElement(
	                      'span',
	                      { style: STYLES.tag },
	                      tag
	                    );
	                  }),
	                  _react2.default.createElement(
	                    'p',
	                    { style: STYLES.subtitle },
	                    post.excerpt
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_mobileContent2.default, null)
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-f37aebf8161f722df18d.js